module.exports = __webpack_public_path__ + "img/bandif.e044eb3.png";